import { create } from 'zustand';
import { apiFetch } from '../api';
import useAdminAuthStore from './adminAuthStore';

const useStudentsStore = create((set, get) => ({
  students: [],
  loading: false,
  error: null,
  addResult: null,

  async fetchStudents() {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await apiFetch('/students', { token });
      set({ students: data, loading: false });
    } catch (e) {
      set({ error: e.message, loading: false });
    }
  },

  async addStudent({ fullName, group }) {
    set({ loading: true, error: null, addResult: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await apiFetch('/students/', {
        method: 'POST',
        body: group ? { fullName, group } : { fullName },
        token,
      });
      set({ addResult: { login: data.login, password: data.password }, loading: false });
      // Можно сразу обновить список, если реализован fetchStudents
      // await get().fetchStudents();
      return data;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  async updateStudent(id, update) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await apiFetch(`/students/${id}`, {
        method: 'PATCH',
        body: update,
        token,
      });
      set({ loading: false });
      return data;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  async getStudentsWithoutGroup() {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await apiFetch('/students', { token });
      const withoutGroup = data.filter(s => !(Array.isArray(s.groups) ? s.groups.length : s.group));
      set({ loading: false });
      return withoutGroup;
    } catch (e) {
      set({ error: e.message, loading: false });
      return [];
    }
  },

  async deleteStudent(id) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      await apiFetch(`/students/${id}`, {
        method: 'DELETE',
        token,
      });
      // После удаления обновляем список
      await get().fetchStudents();
      set({ loading: false });
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  async resetStudentPassword(id) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await apiFetch(`/students/${id}/reset-password`, {
        method: 'PATCH',
        token,
      });
      set({ loading: false });
      return data;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  clearAddResult() {
    set({ addResult: null });
  }
}));

export default useStudentsStore; 